import { Pipe, PipeTransform } from '@angular/core';
import { RoleConstant } from '../../models/role-constant';
import { SelectedUserRoleModel } from 'src/app/models/selected-user-role-model';

@Pipe({
  name: 'userRolesToList'
})

export class SelectedUserRolesToRolePipe implements PipeTransform {

  private roleMap: { [key: string]: string } = {
    [RoleConstant.globalAdminId]: 'Global Admin',
    [RoleConstant.companyAdminId]: 'Company Admin',
    [RoleConstant.srDirectorOperations]: 'Sr. Director Operations',
    [RoleConstant.directorOperations]: 'Director Operations',
    [RoleConstant.supervisor]: 'Supervisor',
    [RoleConstant.generalManager]: 'General Manager',
    [RoleConstant.employeeId]: 'Employee',
    [RoleConstant.vendorId]: 'Vendor',
    [RoleConstant.auditor1]: 'Auditor1',
    [RoleConstant.auditor2]: 'Auditor2',
    [RoleConstant.accountsPayableManager1]: 'AP Manager 1',
    [RoleConstant.accountsPayableManager2]: 'AP Manager 2',
    [RoleConstant.accountsPayableCreator]: 'AP Creator',
    [RoleConstant.vpOperations]: 'VP Operations',
    [RoleConstant.expenseInitiator]: 'Expense Initiator',
    [RoleConstant.RMmanager]: 'RM Manager',
  };

  transform(userRoles: SelectedUserRoleModel[] = []): { roleId: string; roleName: string }[] {
    return userRoles
      .filter(role => !!this.roleMap[role.roleId])
      .map(role => ({
        roleId: role.roleId,
        roleName: this.roleMap[role.roleId]
      }));
  }
}
